import { AsButton, IconDelete } from '@adserve/adserve-react-components';
import React, { useEffect, useState } from 'react';

import { nameOf, nameFromExclusion } from './AutomationSettingsUtils';
import AddingRow from './AddingRow';

const CopyTypeExclusions = ({ campaign, staticData, changeMade, networks, readOnly }) => {
    const descriptionStyle = {
        width: '90%',
        backgroundColor: readOnly ? '#F7F7F7' : '#FFFDF4',
        borderRadius: 5,
        border: '1px solid #D7D7D7',
        height: 32,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: 500
    };

    const emptySelection = () => {
        return {
            copyTypes: [],
            dayParts: [],
            daysOfWeek: [],
            weeks: [],
            stations: []
        };
    };

    const [currentTypes, setCurrentTypes] = useState([]);
    const [currentWeeks, setCurrentWeeks] = useState([]);
    const [currentStations, setCurrentStations] = useState([]);
    const [canAdd, setCanAdd] = useState(false);
    const [addingTypes, setAddingTypes] = useState(emptySelection());

    // default values, in case load from API in useeffect fails
    const [currentDayparts, setCurrentDayparts] = useState([
        { id: window.emptyGuid.substr(0, 35) + '1', name: '00:00 - 06:00' },
        { id: window.emptyGuid.substr(0, 35) + '2', name: '06:00 - 06:00' },
        { id: window.emptyGuid.substr(0, 35) + '3', name: '10:00 - 10:00' },
        { id: window.emptyGuid.substr(0, 35) + '4', name: '13:00 - 16:00' },
        { id: window.emptyGuid.substr(0, 35) + '5', name: '16:00 - 19:00' },
        { id: window.emptyGuid.substr(0, 35) + '6', name: '19:00 - 00:00' }
    ]);

    const [currentDaysOfWeek] = useState([
        { id: window.emptyGuid.substr(0, 34) + '08', name: window.translate('Week Days') },
        { id: window.emptyGuid.substr(0, 34) + '09', name: window.translate('Weekend Days') },

        { id: '', name: '-' },
        {
            id: window.emptyGuid.substr(0, 35) + '1',
            name: window.translate('Monday')
        },
        {
            id: window.emptyGuid.substr(0, 35) + '2',
            name: window.translate('Tuesday')
        },
        {
            id: window.emptyGuid.substr(0, 35) + '3',
            name: window.translate('Wednesday')
        },
        {
            id: window.emptyGuid.substr(0, 35) + '4',
            name: window.translate('Thursday')
        },
        {
            id: window.emptyGuid.substr(0, 35) + '5',
            name: window.translate('Friday')
        },
        {
            id: window.emptyGuid.substr(0, 35) + '6',
            name: window.translate('Saturday')
        },
        {
            id: window.emptyGuid.substr(0, 35) + '7',
            name: window.translate('Sunday')
        }
    ]);

    const initialiseDayParts = () => {
        let newDps = [];
        newDps.push({ id: '', name: '-' });
        if (campaign.applicableDayParts !== undefined) {
            for (let i = 0; i < campaign.applicableDayParts.length; i++) {
                const dp = campaign.applicableDayParts[i];
                newDps.push(dp);
                dp.children = [];
                dp.qtrs = [];
                const startHour = dp.fromTime / 3600;
                const endHour = dp.toTime / 3600;
                const startQtr = dp.fromTime / 900;
                const endQtr = dp.toTime / 900;

                for (let j = startQtr; j < endQtr; j++) {
                    dp.qtrs.push(j);
                }

                for (let j = startHour; j < endHour; j++) {
                    const jpad = j < 10 ? '0' + j : j;
                    const j1 = j + 1;
                    const jpad1 = j1 < 10 ? '0' + j1 : j1;

                    const hour = {
                        id: 'h' + j,
                        name: jpad + ':00-' + jpad1 + ':00',
                        children: [
                            {
                                id: j + ':00',
                                name: jpad + ':00-' + jpad + ':15'
                            },
                            {
                                id: j + ':15',
                                name: jpad + ':15-' + jpad + ':30'
                            },
                            {
                                id: j + ':30',
                                name: jpad + ':30-' + jpad + ':45'
                            },
                            {
                                id: j + ':45',
                                name: jpad + ':45-' + jpad1 + ':00'
                            }
                        ],
                        qtrs: [j * 4 + 0, j * 4 + 1, j * 4 + 2, j * 4 + 3]
                    };
                    dp.children.push(hour);
                }
            }
        } else {
            newDps = currentDayparts;
        }

        campaign.dayParts = newDps;
    };

    useEffect(() => {
        initialiseDayParts();
        setCurrentDayparts(campaign.dayParts);

        const stations = campaign?.campaignStations
            ? campaign?.campaignStations.map((a, b) => {
                  return { id: a.id, name: a.name };
              })
            : campaign?.burstStations.map((a, b) => {
                  return { id: a.id, name: a.name };
              });

        const filteredNets = Object.values(stations);
        filteredNets.unshift({ id: '', name: '-' });

        setCurrentStations(filteredNets);
    }, [networks, campaign]);

    const AddExclusion = () => {
        campaign.exclusions.push({ ...addingTypes });
        setAddingTypes(emptySelection());
        setCanAdd(false);
        changeMade();
    };

    useEffect(() => {}, [campaign?.dealId]);

    useEffect(() => {
        const cts = [];

        // cts.push({ id: window.emptyGuid, name: window.translate('All Copy Types') });
        campaign?.copyTypes?.map((a, b) => {
            return cts.push({ id: a.id, name: nameOf(staticData, a) });
        });
        setCurrentTypes(cts);
        const firstMonday = new Date(campaign?.startDate);
        while (firstMonday.getDay() !== 1) {
            firstMonday.setDate(firstMonday.getDate() - 1);
        }
        const endDate = new Date(campaign?.endDate);
        const days = (endDate - firstMonday) / (1000 * 60 * 60 * 24);

        if (days > 7) {
            const wks = [
                { id: -1, name: window.translate('Odd Weeks') },
                { id: -2, name: window.translate('Even Weeks') },
                { id: 'blank', name: '-' }
            ];
            const numWeeks = Math.ceil(days / 7);
            for (let i = 1; i <= numWeeks; i++) {
                const dt = firstMonday.toString().substr(4, 6);
                firstMonday.setDate(firstMonday.getDate() + 7);
                wks.push({ id: i, name: `Week ${i} w/c ${dt}` });
            }

            setCurrentWeeks(wks);
        } else {
            setCurrentWeeks([]);
        }
    }, [campaign]);

    const updateValues = (newvlsIn, type) => {
        addingTypes[type] = newvlsIn;

        /*  if (currentTypes.length === 2) {
            const indexKey = 'copyTypes';
            if (addingTypes[indexKey].length === 0 && currentTypes[1]?.id)
                addingTypes[indexKey].push(currentTypes[1]?.id);
        }
*/
        let good = false;
        good = good || addingTypes.weeks.length > 0;
        good = good || addingTypes.dayParts.length > 0;
        good = good || addingTypes.daysOfWeek.length > 0;
        // those are simple conditions now more complicated when combining stations and scripts
        if (!good) {
            if (
                currentTypes.length > 2 &&
                addingTypes.copyTypes.length > 0 &&
                currentStations.length > 2 &&
                addingTypes.stations.length > 0
            ) {
                good = good || addingTypes.copyTypes.length * addingTypes.stations.length;
            }
        }

        setAddingTypes({ ...addingTypes });

        setCanAdd(good);
    };

    const deleteRow = (idx) => {
        const newRows = campaign.exclusions.filter((a, b) => b !== idx);
        campaign.exclusions = newRows;
        changeMade();
    };
    const ExclusionTable = ({ campaign, deleteRow }) => {
        const tableStyle = {
            backgroundColor: '#f7f7f7',
            color: '#414141',
            fontSize: 14,
            fontWeight: 500,
            borderCollapse: 'collapse',
            border: '1px solid #d7d7d7',
            width: '90%'
        };

        const tableRows = () => {
            const rows = [];

            campaign?.exclusions?.map((a, b) => {
                rows.push(
                    <tr
                        key={`exclusion${b}`}
                        style={{
                            height: 41,
                            backgroundColor: b % 2 ? '#f7f7f7' : 'white'
                        }}
                    >
                        <td style={{ width: 41, textAlign: 'center' }}>
                            <IconDelete
                                style={{ width: 18, height: 18 }}
                                fill={readOnly ? '#CCCCCC' : '#414141'}
                                onClick={() => deleteRow(b)}
                                disabled={readOnly}
                            />
                        </td>
                        <td style={{ paddingLeft: 10 }}>
                            {nameFromExclusion(
                                campaign,
                                staticData,
                                currentDaysOfWeek,
                                currentDayparts,
                                currentWeeks,
                                a
                            )}
                        </td>
                    </tr>
                );
                return true;
            });
            for (let i = rows.length; i < 6; i++) {
                rows.push(
                    <tr
                        key={`exclusion${i}`}
                        style={{
                            height: 41,
                            backgroundColor: i % 2 ? '#f7f7f7' : 'white'
                        }}
                    >
                        <td style={{ width: 41, textAlign: 'center' }}>
                            <IconDelete style={{ width: 18, height: 18 }} fill='#CCCCCC' disabled={true} />
                        </td>
                        <td></td>
                    </tr>
                );
            }
            return rows;
        };
        return (
            <div style={{ height: 300, overflow: 'hidden auto', width: '100%' }}>
                <table border='1' style={{ ...tableStyle, width: '100%' }}>
                    <tbody>
                        <tr style={{ height: 41 }}>
                            <td colSpan={2}>
                                <span style={{ fontSize: 15, marginLeft: 71 }}>{window.translate('Exclude ...')}</span>
                            </td>
                        </tr>
                        {tableRows()}
                    </tbody>
                </table>
            </div>
        );
    };
    const ClearExclusions = () => {
        campaign.exclusions = [];
        changeMade();
    };
    const layoutBoxStyle = {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        borderRight: '1px solid #E3E3E3',
        height: 81,
        margin: 0,
        backgroundColor: '#FFFFFF'
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                color: '#414141'
            }}
        >
            <span
                style={{
                    fontSize: 15,
                    fontWeight: 500,
                    marginTop: 17,
                    marginBottom: 11
                }}
            >
                {window.translate('Exclusions')}
            </span>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateAreas: "'title' 'header' 'content' 'footer'",
                        gridTemplateRows: '33px 81px 281px 11px',
                        gridTemplateColumns: '4fr 1fr',
                        width: '95%',
                        border: '1px solid #E3E3E3'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: 57
                        }}
                    >
                        <span style={{ fontSize: 12 }}>
                            {window.translate('Select campaign exclusion rules from the drop down types below.')}
                        </span>
                    </div>
                    <div />
                    <div
                        style={{
                            display: 'flex',
                            borderTop: '1px solid #E3E3E3',
                            gridColumnStart: 1,
                            gridColumnEnd: 3
                        }}
                    >
                        <AddingRow
                            campaign={campaign}
                            readOnly={readOnly}
                            layoutBoxStyle={layoutBoxStyle}
                            currentTypes={currentTypes}
                            addingTypes={addingTypes}
                            currentStations={currentStations}
                            currentWeeks={currentWeeks}
                            updateValues={updateValues}
                            currentDayparts={currentDayparts}
                            descriptionStyle={descriptionStyle}
                            currentDaysOfWeek={currentDaysOfWeek}
                            canAdd={canAdd}
                            AddExclusion={AddExclusion}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            borderTop: '1px solid #E3E3E3',
                            gridColumnStart: 1,
                            gridColumnEnd: 3
                        }}
                    >
                        <ExclusionTable campaign={campaign} deleteRow={deleteRow}></ExclusionTable>
                    </div>
                    <div />
                    <div style={{ borderTop: '1px solid #E3E3E3' }} />
                    <div />
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '84%'
                }}
            >
                <AsButton
                    handleClick={ClearExclusions}
                    useSecondaryStyle
                    style={{
                        width: 120,
                        fontSize: 15,
                        fontWeight: 'bold',
                        marginTop: 20,
                        marginBottom: 20
                    }}
                    disabled={readOnly}
                >
                    {window.translate('Clear All')}
                </AsButton>
            </div>
        </div>
    );
};
export default CopyTypeExclusions;
